import {
  AppVersionDto,
  appVersionQueryType,
  IAppVersionDatastore
} from "dev-center-lib";

import { prepareUrl, request } from "../common/apiClient";

import config from "../config.json";

export class AppVersionDatastoreRestClient implements IAppVersionDatastore {
  public addAsync(appVersionDto: AppVersionDto) {
    return new Promise<AppVersionDto>(async (resolve, reject) => {
      try {
        const newAppVersionDto = await request<AppVersionDto>(
          prepareUrl(`${config.apiServer}/administrators/app-versions`),
          {
            body: appVersionDto,
            method: "POST"
          }
        );

        resolve(new AppVersionDto(newAppVersionDto));
      } catch (error) {
        reject(error);
      }
    });
  }

  public findAsync(query: appVersionQueryType) {
    return new Promise<{
      dtos: AppVersionDto[],
      objectsPerPage: number,
      pageNumber: number,
      totalObjectCount: number,
      totalPageCount: number
    }>(
      async (resolve, reject) => {
        try {
          const response = await request<{
            dtos: AppVersionDto[],
            objectsPerPage: number,
            pageNumber: number,
            totalObjectCount: number,
            totalPageCount: number
          }>(
            prepareUrl(
              `${config.apiServer}/administrators/app-versions`,
              query
            )
          );

          response.dtos = response.dtos.map((dto) => (new AppVersionDto(dto)));
          resolve({ ...response });
        } catch (error) {
          reject(error);
        }
      }
    );
  }

  public getAsync(id: number) {
    return new Promise<AppVersionDto>(async (resolve, reject) => {
      try {
        const appVersionDto = await request<AppVersionDto>(
          prepareUrl(
            `${config.apiServer}/administrators/app-versions/${id}`
          )
        );
        resolve(new AppVersionDto(appVersionDto));
      } catch (error) {
        reject(error);
      }
    });
  }

  public removeAsync(id: number) {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await request(
          prepareUrl(
            `${config.apiServer}/administrators/app-versions/${id}`
          ),
          { method: "DELETE" }
        );

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  public updateAsync(appVersionDto: AppVersionDto) {
    return new Promise<AppVersionDto>(async (resolve, reject) => {
      try {
        const updateAppVersionDto = await request<AppVersionDto>(
          prepareUrl(
            `${config.apiServer}/administrators/app-versions/${appVersionDto.id}`
          ),
          {
            body: appVersionDto,
            method: "PATCH"
          }
        );

        resolve(new AppVersionDto(updateAppVersionDto));
      } catch (error) {
        reject(error);
      }
    });
  }
}
